  import { fieldName } from '../../CommonFunctions/CommonFunctions';
  import ChartsInfo from '../../ChartAxes/ChartsInfo2';

  //  hasChartData
  export const hasChartData = (propKey: string, chartControls: any) => {
    return (
      chartControls.properties[propKey]?.chartData &&
      chartControls.properties[propKey].chartData.length > 0
    );
  };

  //  getFieldsToChartAllowedNumbers
  export const getFieldsToChartAllowedNumbers = (
    chartName: string,
    chartAxesIndex: number,
    arr1: any,
    arr2?: any,
  ) => {
    const allowedNumbers = ChartsInfo[chartName]?.dropZones[chartAxesIndex]?.allowedNumbers ?? 1;

    if (arr1 && arr1.length > 0) {
      if (allowedNumbers > arr1.length) {
        return arr2 && arr2.length > 0 ? [...arr1, ...arr2].slice(0, allowedNumbers) : arr1;
      } else {
        return allowedNumbers === arr1.length ? arr1 : arr1.slice(0, allowedNumbers);
      }
    } else if (arr2 && arr2.length > 0) {
      return arr2.slice(0, allowedNumbers);
    } else {
      return [];
    }
  };

  //  clearOverRideOnChartChange
  export const clearOverRideOnChartChange = (
    newChart: string,
    oldChart: string,
    newChartAxes: any,
    propKey: string,
    updateQueryParam: (
      propKey: string,
      bIndex: number,
      idx: number,
      field: any,
      type: string,
    ) => void,
    enableOverrideForUIDAction: (propKey: string, uid: string) => void,
  ) => {
    const isNewChart = [
      'multibar',
      'stackedBar',
      'horizontalBar',
      'horizontalStacked',
      'line',
      'area',
      'stackedArea',
      'pie',
      'donut',
      'rose',
      'waterfall',
      'wordCloud',
    ].includes(newChart);
    const isOldChart = [
      'multibar',
      'stackedBar',
      'horizontalBar',
      'horizontalStacked',
      'line',
      'area',
      'stackedArea',
      'pie',
      'donut',
      'rose',
      'waterfall',
      'wordCloud',
    ].includes(oldChart);

    if (!isNewChart || !isOldChart) {
      const axes = newChartAxes.filter((axis: any) => axis.name !== 'Filter');

      axes.forEach((axis: any, bIndex: number) => {
        axis.fields.forEach((field: any, idx: number) => {
          const updatedField = { ...field, override: null };
          updateQueryParam(propKey, bIndex + 1, idx, updatedField, 'chartAxes');
          enableOverrideForUIDAction(propKey, '');
        });
      });
    }
  };

  //  IsOldChartFieldsCountIsGreater
  export const IsOldChartFieldsCountIsGreater = (
    newChartName: string,
    chartAxesIndex: number,
    propKey: string,
    chartProp: any,
  ): boolean => {
    const oldChartAxesFieldsCount =
      chartProp.properties[propKey]?.chartAxes[chartAxesIndex]?.fields?.length || 0;
    const newAllowedNumbers =
      ChartsInfo[newChartName]?.dropZones[chartAxesIndex]?.allowedNumbers || 0;

    return oldChartAxesFieldsCount > newAllowedNumbers;
  };

  //  UpdateChartDataWithNewChartAxes
  export const UpdateChartDataWithNewChartAxes = (
    oldAxes: any,
    newAxes: any,
    index: number,
    propKey: string,
    chartControls: any,
    updateChartData: (propKey: string, data: any) => void,
  ) => {
    let chartData = chartControls.properties[propKey]?.chartData
      ? JSON.parse(JSON.stringify(chartControls.properties[propKey].chartData))
      : [];

    const keys = newAxes[index].fields.map((field: any) => field.fieldname);
    const keysToRemove = oldAxes[index].fields
      .filter((field: any) => !keys.includes(field.fieldname))
      .map((field: any) => fieldName(field));

    chartData = chartData.map((data: any) => {
      keysToRemove.forEach((key: string) => delete data[key]);
      return data;
    });

    updateChartData(propKey, chartData);
  };
